import { render, staticRenderFns } from "./CombatPlayersScore.vue?vue&type=template&id=78924fa9&scoped=true"
import script from "./CombatPlayersScore.vue?vue&type=script&lang=js"
export * from "./CombatPlayersScore.vue?vue&type=script&lang=js"
import style0 from "./CombatPlayersScore.vue?vue&type=style&index=0&id=78924fa9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78924fa9",
  null
  
)

export default component.exports